import angular from 'angular';

import componentNameForFieldType from '../fields';
import { imageSrcTokenParams } from '../../staffToken';
import { convertPlainTextStringToBasicMarkup, cacheBustImages, escapeHtml, fieldNameIsMarkup } from '../../util';

class RecapResponseFieldInstanceController {
  constructor(
    $scope,
    $log,
    $q,
    $element,
    $compile,
    $sce,
    $translate,
    LanguageService,
    APIService,
    DEBUG
  ) {
    "ngInject";
    this.$scope = $scope;
    this.$log = $log;
    this.$q = $q;
    this.$element = $element;
    this.$compile = $compile;
    this.$sce = $sce;
    this.$translate = $translate;
    this._valueChanged = false;
    this.LanguageService = LanguageService;
    this.APIService = APIService;
    this.DEBUG = DEBUG;
  }

  $postLink() {
    return this._addFieldComponent();
  }

  $onInit() {
    this.$scope.$watch(() => this.fieldResponse.currentValue, (newVal, oldVal, scope) => {
      if (newVal !== oldVal) {
        return this._handleFieldResponseValueChanged();
      }
    });
    this.$scope.$watch(() => {
      return this.fieldResponse
        && this.fieldResponse.documentsToUpload
        && this.fieldResponse.documentsToUpload.length;
    }, (newNumDocs, oldNumDocs) => {
      if (newNumDocs !== oldNumDocs) {
        return this._handleFieldResponseValueChanged();
      }
    });
  }

  _handleFieldResponseValueChanged() {
    this._valueChanged = true;
    this.$scope.$emit('updateDisplayLogic', this.fieldResponse);
    this.$scope.$emit('recapFieldTouched', { fieldResponse: this.fieldResponse });
  }

  get fieldResponse() {
    return this._fieldResponse;
  }

  set fieldResponse(fieldResponse) {
    this._fieldResponse = fieldResponse;
  }

  get fieldInstance() {
    return this._fieldResponse.fieldInstance;
  }

  get field() {
    return this.fieldInstance.field;
  }

  get fieldType() {
    return this.field.fieldType;
  }

  get validations() {
    return this.fieldInstance.validations;
  }

  get fieldHasInput() {
    return !this.field.isSubsectionField;
  }

  get hasError() {
    return this.fieldResponse.errors.length > 0;
  }

  get isEmpty() {
    return this.fieldResponse.isEmpty;
  }

  get required() {
    return this.fieldResponse.required;
  }

  get formattedDisplayText() {
    const translatedText = this.LanguageService.translateProperty(this.field, 'name');
    const text = translatedText || '';
    // Deliberately NOT $sce.trustAsHtml: the name is user data, and trusting it ran any markup saved
    // into a display text field for every staffer filling the recap (GH-5558). A name written with
    // "Use HTML" is markup, so it goes out untrusted and ng-bind-html runs it through ngSanitize,
    // which keeps formatting and safe links and drops scripts and handlers. Any other name is plain
    // text and is escaped first, so "a < b" reads as typed and only the <p>/<br> added here is markup.
    const source = fieldNameIsMarkup(this.field, text) ? text : escapeHtml(text);
    return convertPlainTextStringToBasicMarkup(source);
  }

  get displayImageURL() {
    if (this.field && this.field.isDisplayImageField && this.field.image) {
      setTimeout(() => {
        cacheBustImages()
      }, 200)
      return this.APIService.convertAbsolutePathToURL(
        this.field.image,
        imageSrcTokenParams(this.field.image, this.APIService.getAuthToken())
      );
    }
    return '';
  }

  get displayImageAltText() {
    return this.LanguageService.translateProperty(this.field, 'name');
  }

  get shouldDisplayFieldInstance() {
    return !this.field.isSubsectionField && !this.field.isDisplayTextField && !this.field.isDisplayImageField;
  }

  get shouldDisplayInfoDisclosureText() {
    return this.field.use_info_disclosure_text;
  }

  get shouldDisplayInfoDisclosureTextInsideFieldInstance() {
    return this.shouldDisplayInfoDisclosureText && this.shouldDisplayFieldInstance;
  }

  get shouldDisplayInfoDisclosureTextOutsideFieldInstance() {
    return this.shouldDisplayInfoDisclosureText && !this.shouldDisplayFieldInstance;
  }

  _addFieldComponent() {
    const newScope = this.$scope.$new(true, this.$scope);
    newScope.fieldResponse = this.fieldResponse;
    newScope.inputId = this.inputId;

    const passVars = {
      'field-response': 'fieldResponse',
    };
    const passHtml = Object.keys(passVars)
      .map(key => key + '="' + passVars[key] + '"')
      .join(' ');

    const fieldComponentName = componentNameForFieldType(this.fieldType);
    if (!fieldComponentName) {
      this.$log.error("Unable to find component for field type", this.fieldType);
      return;
    }

    const elementName = fieldComponentName.replace(/([A-Z])/g, '-$1').toLowerCase();
    const html = '<' + elementName + ' ' + passHtml + '></' + elementName + '>';
    const compiled = this.$compile(html)(newScope);
    //this.$log.info("HTML:", html, "compiled:", compiled);
    this._getFieldWrapperElement().append(compiled);
  }

  _getFieldWrapperElement() {
    const el = this.$element[0].querySelector('.fieldinstance-field');
    return angular.element(el);
  }
}

export default RecapResponseFieldInstanceController;
